import playstore from "@/assets/icons/playstore.png"

const icons = {
  playstore
}

function getImagePaths(projectFolder) {
  const context = require.context(
    "@/assets/images/projects",
    true,
    /\.png$/
  )

  return context
    .keys()
    .filter(path =>
      path.includes(`./${projectFolder}/screenshots/`)
    )
    .sort((a, b) =>
      a.localeCompare(b, undefined, {
        numeric: true
      })
    )
}

function loadImages(projectFolder) {
  const context = require.context(
    "@/assets/images/projects",
    true,
    /\.png$/
  )

  const paths = getImagePaths(projectFolder)

  return paths.map(path => context(path))
}

const images = {
  renegado: {
    icon: require("@/assets/images/projects/renegado/renegadoIcon.png"),

    screenshots: loadImages("renegado"),
  },

  dioroom: {
    icon: require("@/assets/images/projects/dioroom/dioroomIcon.png"),

    screenshots: loadImages("dioroom"),
  }
}

export const projectsTitle = {
  pt: {
    first: "NOSSOS",
    second: "PROJETOS",

    description:
      "Conheça os projetos que desenvolvemos e os que estão em produção"
  },

  en: {
    first: "OUR",
    second: "PROJECTS",

    description:
      "Discover the projects we have developed and those currently in production"
  }
}

export const projects = [
  {
    id: 1,

    name: "Dioroom",

    year: "2026",

    image: images.dioroom.icon,


    badgeClass: "badge-upcoming",

    bgClass: "purple-bg",


    link:
      "https://play.google.com/store/apps/details?id=com.BlackPaladins.Dioroom",

    storeIcon: icons.playstore,

    icon: images.dioroom.icon,

    screenshots: images.dioroom.screenshots,

    trailer:
      "https://www.youtube.com/embed/Eu1Cb1w9Sc0",

    playstoreLink:
      "https://play.google.com/store/apps/details?id=com.BlackPaladins.Dioroom",

    privacyPolicy: "dioroom-privacy-policy",

    visible: true,

    available: false,

    stores: ["Google Play"],

    en: {

      releaseDate: "2026",

      description:
        `DioRoom is a casual game focused on relaxing puzzles.
        It tells the story of two friends who become trapped in a world of dioramas.`,

      badge: "upcoming",

      tags: ["puzzle", "casual"],

      download: "Download now"

    },

    pt: {

      releaseDate: "2026",

      description:
        `DioRoom é um jogo casual, focado em puzzles relaxantes. 
        Conta a história de dois amigos que ficam presos em um mundo de dioramas.`,

      badge: "Em breve",

      tags: ["quebra-cabeças", "casual"],

      download: "Baixe agora"
    }
  },

  {
    id: 2,

    name: "Renegado",

    year: "2021",

    image: images.renegado.icon,

    badgeClass: "badge-released",

    bgClass: "red-bg",


    link:
      "https://play.google.com/store/apps/details?id=com.BlackPaladins.Renegado",

    storeIcon: icons.playstore,

    icon: images.renegado.icon,

    screenshots: images.renegado.screenshots,

    trailer:
      "https://www.youtube.com/embed/Eu1Cb1w9Sc0",

    playstoreLink:
      "https://play.google.com/store/apps/details?id=com.BlackPaladins.Renegado",

    privacyPolicy: "renegado-privacy-policy",

    visible: true,

    available: true,

    stores: ["Google Play"],
    en: {

      releaseDate: "2021",

      description:
        `Renegado is a Western-themed shooter 
        where a cowboy must face enemies through intense action and gunfights.`,

      badge: "released",
    
      tags: ["action", "shooter"],

      download: "Download now"
    },

    pt: {

      releaseDate: "2021",

      description:
        `Renegado é um jogo de tiro situada no faroeste, 
        onde um cowboy precisa enfrentar inimigos com muita ação e tiroteio.`,

      badge: "Lançado em",

      tags: ["ação", "tiro"],

      download: "Baixe agora"
    }
  }
]